module.exports = __webpack_public_path__ + "static/media/400071_02.63f1f397.png";